// API Configuration
const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;


export const API_ENDPOINTS = {
  // Auth endpoints
  LOGIN: `${API_BASE_URL}/api/v1/auth/login`,
  REGISTER: `${API_BASE_URL}/api/v1/auth/register`,
  FORGOT_PASSWORD: `${API_BASE_URL}/api/v1/auth/forgot-password`,
  RESET_PASSWORD: `${API_BASE_URL}/api/v1/auth/reset-password`,
  VERIFY_EMAIL: `${API_BASE_URL}/api/v1/auth/verify-email-code`,
  SEND_EMAIL_VERIFICATION: `${API_BASE_URL}/api/v1/auth/send-email-verification`,

  // User endpoints
  USER_PROFILE: `${API_BASE_URL}/api/v1/users/profile`,
  USER_STATISTICS: `${API_BASE_URL}/api/v1/users/statistics`,
  USER_SEARCH: `${API_BASE_URL}/api/v1/user-search/search`,

  // Wallet endpoints
  WALLET_BALANCE: `${API_BASE_URL}/api/v1/wallets/balance`,
  WALLET_TRANSACTIONS: `${API_BASE_URL}/api/v1/wallets/transactions`,

  // Chama endpoints
  MY_CHAMAS: `${API_BASE_URL}/api/v1/chamas/my`,
  CREATE_CHAMA: `${API_BASE_URL}/api/v1/chamas/`,
  CHAMA_DETAILS: (chamaId) => `${API_BASE_URL}/api/v1/chamas/${chamaId}`,
  CHAMA_MEMBERS: (chamaId) => `${API_BASE_URL}/api/v1/chamas/${chamaId}/members`,
  CHAMA_MEETINGS: (chamaId) => `${API_BASE_URL}/api/v1/meetings/?chamaId=${chamaId}`,
  CHAMA_TRANSACTIONS: (chamaId) => `${API_BASE_URL}/api/v1/chamas/${chamaId}/transactions`,
  CHAMA_POLLS: (chamaId) => `${API_BASE_URL}/api/v1/chamas/${chamaId}/polls/`,
  CHAMA_STATISTICS: (chamaId) => `${API_BASE_URL}/api/v1/chamas/${chamaId}/statistics`,

  // Meeting endpoints
  USER_MEETINGS: `${API_BASE_URL}/api/v1/meetings/user`,

  // Contribution endpoints
  CONTRIBUTIONS: `${API_BASE_URL}/api/v1/contributions`,

  // Chama member role endpoint
  CHAMA_MEMBER_ROLE: (chamaId, userId) => `${API_BASE_URL}/api/v1/chamas/${chamaId}/members/${userId}/role`,

  // Merry-go-round endpoints
  MERRY_GO_ROUND_CONTRIBUTION_STATUS: (chamaId) => `${API_BASE_URL}/api/v1/merry-go-rounds/contribution-status/${chamaId}`,

  // Meeting endpoints
  MEETINGS: `${API_BASE_URL}/api/v1/meetings/`,
  MEETINGS_CALENDAR: `${API_BASE_URL}/api/v1/meetings/calendar`,

  // Payment endpoints
  MPESA_STK_PUSH: `${API_BASE_URL}/api/v1/payments/mpesa/stkpush`,
};

export default API_BASE_URL;